import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { hideActivePopup } from 'Store/Overlay/Overlay.action';
import { ProductType, ProductVariationsItemType } from 'Type/ProductList.type';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

import ProductVariation from './ProductVariation.component';

/** @namespace PeggysagePwa/Component/ProductVariation/Container/mapStateToProps */
export const mapStateToProps = () => ({
    // ...
});

/** @namespace PeggysagePwa/Component/ProductVariation/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    hideActivePopup: () => dispatch(hideActivePopup())
});

/** @namespace PeggysagePwa/Component/ProductVariation/Container */
export class ProductVariationContainer extends PureComponent {
    static propTypes = {
        hideActivePopup: PropTypes.func.isRequired,
        product: ProductType.isRequired,
        variation: ProductVariationsItemType.isRequired,
        isLimited: PropTypes.bool,
        isSelect: PropTypes.bool,
        isInCart: PropTypes.bool,
        onClickVariation: PropTypes.func
    };

    static defaultProps = {
        isLimited: false,
        isSelect: false,
        isInCart: false,
        onClickVariation: null
    };

    state = {
        isAlertExpanded: false
    };

    containerFunctions = {
        onClickAlertButton: this.onClickAlertButton.bind(this),
        onClickVariation: this.onClickVariation.bind(this)
    };

    containerProps() {
        const {
            product,
            variation,
            isLimited,
            isSelect,
            isInCart
        } = this.props;
        const { isAlertExpanded } = this.state;

        return {
            product,
            variation,
            isLimited,
            isSelect,
            isInCart,
            isAlertExpanded
        };
    }

    onClickAlertButton() {
        const { isAlertExpanded } = this.state;

        this.setState({ isAlertExpanded: !isAlertExpanded });
    }

    onClickVariation(e) {
        const {
            onClickVariation,
            variation,
            variation: {
                url_key
            },
            hideActivePopup
        } = this.props;

        if (onClickVariation) {
            e.preventDefault();
            e.stopPropagation();
            onClickVariation(e, variation);
        } else {
            hideActivePopup();
            setTimeout(() => {
                history.push(appendWithStoreCode(url_key));
                // eslint-disable-next-line no-magic-numbers
            }, 100);
        }
    }

    render() {
        return (
            <ProductVariation
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductVariationContainer);
